import { ProjectModel } from '../types';

export enum MySupervisionsActionType {
    APPROVE_PROJECT = 'APPROVE_PROJECT',
    DECLINE_PROJECT = 'DECLINE_PROJECT',
    GET_INVOLVED_PROJECTS = 'GET_INVOLVED_PROJECTS',
    REVIEW_PROJECT_CHANGES = 'REVIEW_PROJECT_CHANGES',
    GET_MY_SUPERVISIONS = 'GET_MY_SUPERVISIONS',
}

interface GetInvolvedProjectsAction {
    type: MySupervisionsActionType.GET_INVOLVED_PROJECTS;
    payload: { projects: Array<ProjectModel> };
}

interface GetMySupervisionsAction {
    type: MySupervisionsActionType.GET_MY_SUPERVISIONS;
    payload: { projects: Array<ProjectModel> };
}

interface ApproveProjectAction {
    type: MySupervisionsActionType.APPROVE_PROJECT;
    payload: ProjectModel;
}

interface DeclineProjectAction {
    type: MySupervisionsActionType.DECLINE_PROJECT;
    payload: ProjectModel;
}

interface ReviewProjectChangesAction {
    type: MySupervisionsActionType.REVIEW_PROJECT_CHANGES;
    payload: ProjectModel;
}

export type MySupervisionsAction =
    | GetInvolvedProjectsAction
    | GetMySupervisionsAction
    | ApproveProjectAction
    | DeclineProjectAction
    | ReviewProjectChangesAction;
